import React, {Component} from 'react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions
} from "@mui/material";

export default class NoteDialog extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            dialogTitle: "",
            dialogBody: "",
            btnAgreeText: "Zavřít",
        };

        this.handleAgreement = this.handleAgreement.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    Open(dialogBodyText,dialogTitleText) {
        this.setState({
            dialogBody: dialogBodyText,
            dialogTitle: dialogTitleText,
            open: true
        });
    }

    handleAgreement(event) {
        this.setState({open:false});
        this.props.AgreementCallback();
    }

    handleClose() {
        this.setState({open: false});
    }

    render() {
        return (

            <div>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">{this.state.dialogTitle}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {this.state.dialogBody}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleAgreement} color="primary"  >
                            {this.state.btnAgreeText}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}
